import { axiosInstance } from "@/utilities";
import { API_BASE_URL } from "@/services/XCONS_ENV";

const sellerBase = (sellerCode: string) =>
  `${API_BASE_URL}/sellers/${encodeURIComponent(sellerCode)}`;

export interface SellerSettings {
  code: string;
  name: string;
  email: string;
  legalName: string;
  taxvat: string;
  phone?: string;
  whatsapp?: string;
  storeHours?: string;
  regionId?: number;
  postcode?: string;
  city?: string;
  street?: string;
  latitude?: number;
  longitude?: number;
  mainColor?: string;
  extraInfo?: string;
  xconsPlan?: string;
  comissionFee?: number;
  logo?: string;
  squareLogo?: string;
  /**
   * URLs absolutas que deriva el GET para poder mostrar la imagen. Lo que se
   * guarda es el path relativo de `logo` / `squareLogo`: la columna de Magento
   * es relativa y el storefront le antepone la base de media del ambiente.
   * El PATCH las acepta y las ignora.
   */
  logoUrl?: string | null;
  squareLogoUrl?: string | null;
}

export async function getSellerSettings(sellerCode: string): Promise<SellerSettings> {
  const { data } = await axiosInstance.get<SellerSettings>(sellerBase(sellerCode));
  return data;
}

export async function updateSellerSettings(
  sellerCode: string,
  payload: Partial<SellerSettings>,
): Promise<SellerSettings> {
  const { data } = await axiosInstance.patch<SellerSettings>(sellerBase(sellerCode), payload);
  return data;
}
